<template>
  <div class="create">
    <!-- card -->
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>字典创建</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/dictionary')"
          >返回</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <tz-form
        width="110px"
        :formConfig="formConfig"
        :formBtns="formBtns"
        @submit="submitFn"
      ></tz-form>
      <!-- card content -->
    </el-card>
    <!-- card -->
  </div>
</template>

<script>
import { addDict } from '@/api/dictionary'

export default {
  data() {
    return {
      // 表单配置
      formConfig: [
        {
          label: '标签',
          field: 'label',
          type: 'text',
          rules: [{ required: true, message: '标签必填', trigger: 'blur' }]
        },
        {
          label: '排序',
          field: 'sort',
          type: 'text',
          rules: [
            { required: true, message: '排序必填', trigger: 'blur' }
            // { min: 1, max: 5, message: '简写长度为1到5', trigger: 'blur' }
          ]
        },
        {
          label: '类型',
          field: 'type',
          type: 'text',
          rules: [{ required: true, message: '类型必填', trigger: 'blur' }]
        },
        {
          label: '内容',
          field: 'value',
          type: 'text',
          rules: [{ required: true, message: '内容必填', trigger: 'blur' }]
        },
        {
          label: '描述',
          field: 'description',
          type: 'text'
          // rules: [{ required: true, message: '描述必填', trigger: 'blur' }]
        }
        // {
        //   label: '手机号',
        //   field: 'mobilePhone',
        //   type: 'text',
        //   rules: [
        //     { required: true, message: '手机号必填', trigger: 'blur' },
        //     {
        //       validator: this.checkMobilePhone,
        //       trigger: 'blur'
        //     }
        //   ]
        // },
        // {
        //   label: '角色',
        //   field: 'roleId',
        //   type: 'select',
        //   payload: [],
        //   rules: [{ required: true, message: '角色必填', trigger: 'blur' }]
        // },
        // {
        //   label: '密码',
        //   field: 'password',
        //   type: 'password',
        //   showPwd: true,
        //   rules: [{ required: true, message: '密码必填', trigger: 'blur' }]
        // }
      ],
      formBtns: [
        {
          content: '创建',
          width: '185px',
          type: 'primary'
        }
      ]
    }
  },
  methods: {
    submitFn(formData) {
      console.log(formData, '字典创建')
      if (this.submited) return
      this.$loading({
        text: '字典添加中'
      })
      let dictinfo = JSON.parse(JSON.stringify(formData))
      let addparams = {
        label: dictinfo.label,
        sort: dictinfo.sort,
        value: dictinfo.value,
        description: dictinfo.description,
        type: dictinfo.type
      }
      addDict(addparams).then((res) => {
        console.log(res.data, '创建')
        if (res.code == 200) {
          this.submited = true
          this.$message({
            message: '添加成功',
            type: 'success'
          })
          this.$router.go(-1)
        } else {
          this.$message({
            message: res.data,
            type: 'error'
          })
        }
      })
      this.$loading().close()
    }
  }
}
</script>

<style></style>
